import { gql } from '@apollo/client';

// Main consignment query (updated for schema)
export const GET_CONSIGNMENT = gql`
  query GetConsignment($id: ID!) {
    consignment {
      get(id: $id) {
        id
        billOfLadingNbr
        containerNbrs
        carrier
        originCountry
        countryOfImport
        dischargeCountry
        productDivisions
        modeOfTransport
        expectedShipmentCount
        actualShipmentCount
        workflowInstance {
          workflowInstanceId
          workflowDefinitionName
          workflowDefinitionURI
        }
        openExceptionCount
        exceptions(limit: 10, offset: 0) {
          items {
            id
            alias
            description
            status
            stepTitle
          }
          pageInfo {
            totalCount
            status
            message
          }
        }
        steps {
          title
          status
          startTimestamp
          completedTimestamp
          context {
            badge
            context
          }
        }
        equipmentVehicle {
          id
          voyageNumber
          plannedDischargeDate
          modeOfTransport
          carrier
          originCountry
          dischargeCountry
          openExceptionCount
          consignmentCount
          expectedShipmentCount
          actualShipmentCount
          health {
            health
            description
          }
        }
        auditTrail(limit: 25, offset: 0, order: ASC) {
          items {
            ... on ConsignmentAuditStepEntry {
              id
              timestamp
              stepTitle
            }
            ... on ConsignmentAuditExceptionEntry {
              id
              timestamp
              exceptionId
              exceptionAlias
              exceptionStatus
            }
          }
          pageInfo {
            totalCount
            status
            message
          }
        }
        health {
          health
          description
        }
        involvedParties {
          type
          id
          name
          address {
            addressLine1
            cityName
            postalCode
            countryCode
            provinceStateRegionCode
          }
          contactDetails {
            email
            phone
          }
        }
        # filingPacks {
        #   id
        #   fileName
        #   downloadUrl
        #   latestStatus
        #   latestMessage
        #   latestTimestamp
        #   createdAt
        #   createdBy
        #   stepTitle
        #   statuses {
        #     status
        #     message
        #     timestamp
        #     customsReferenceNumber
        #     brokerReferenceNumber
        #     downloadUrl
        #   }
        #   customsEntries {
        #     timestamp
        #     customsReferenceNumber
        #     downloadUrl
        #   }
        # }
        documents {
          ... on FilingPackDocument {
            id
            type
            fileName
            downloadUrl
            createdAt
            createdBy
            stepTitle
            latestStatus
            latestMessage
            latestTimestamp
          }
          ... on CustomsStatusDocument {
            id
            type
            fileName
            downloadUrl
            createdAt
            createdBy
            stepTitle
            filingPackId
            status
            message
            timestamp
            customsReferenceNumber
            brokerReferenceNumber
          }
          ... on CustomsEntryDocument {
            id
            type
            fileName
            downloadUrl
            createdAt
            createdBy
            stepTitle
            filingPackId
            timestamp
            customsReferenceNumber
            brokerReferenceNumber
          }
        }
      }
    }
  }
`;

// Query for consignment filing packs (separate query for downloads)
export const GET_CONSIGNMENT_DOCUMENTS = gql`
  query GetConsignmentDocuments($id: ID!) {
    consignment {
      get(id: $id) {
        id
        # filingPacks {
        #   id
        #   fileName
        #   downloadUrl
        #   latestStatus
        #   latestMessage
        #   latestTimestamp
        #   createdAt
        #   createdBy
        #   stepTitle
        #   statuses {
        #     status
        #     message
        #     timestamp
        #     customsReferenceNumber
        #     brokerReferenceNumber
        #     downloadUrl
        #   }
        #   customsEntries {
        #     timestamp
        #     customsReferenceNumber
        #     downloadUrl
        #   }
        # }
        documents {
          ... on FilingPackDocument {
            id
            type
            fileName
            downloadUrl
            createdAt
            createdBy
            stepTitle
            latestStatus
            latestMessage
            latestTimestamp
          }
          ... on CustomsStatusDocument {
            id
            type
            fileName
            downloadUrl
            createdAt
            createdBy
            stepTitle
            filingPackId
            status
            message
            timestamp
            customsReferenceNumber
            brokerReferenceNumber
          }
          ... on CustomsEntryDocument {
            id
            type
            fileName
            downloadUrl
            createdAt
            createdBy
            stepTitle
            filingPackId
            timestamp
            customsReferenceNumber
            brokerReferenceNumber
          }
        }
      }
    }
  }
`;